import Carousel from "@/components/carousel";
import Modal from "@/components/modal";
import { ProductCard } from "@/components/product-card";
import { FC, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CombiDealModal as CombiDealModalType } from "@/store/ui/types";
import styles from "./CombiDealModal.module.scss";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { dismissCombiDealModal } from "@/store/ui/slice";
import { Product } from "@/types/product";
import { addProduct } from "@/store/cart/thunk";
import { formatMoney } from "@/helpers/numbers";
import ScannerHandler from "@/helpers/ScannerHandler";

const CombiDealModal: FC<CombiDealModalType> = ({ ...combiDealModal }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const onClose = useCallback(() => {
    dispatch(dismissCombiDealModal(combiDealModal));
  }, [dispatch, combiDealModal]);

  const onClick = (productId: Product["id"]) => {
    dispatch(addProduct(productId));
    onClose();
  };

  const price =
    combiDealModal.priceCents !== undefined
      ? formatMoney(combiDealModal.priceCents / 100)
      : undefined;

  useEffect(() => {
    const scannerHandler = new ScannerHandler(onClose);
    scannerHandler.start();
    return () => scannerHandler.stop();
  }, [onClose]);

  return (
    <Modal
      title={t("mainPage.combiDeals.title")}
      onClose={onClose}
      visible
      data-cy="combi-deal-modal">
      <p>
        {price
          ? t("mainPage.combiDeals.message", { price })
          : t("mainPage.combiDeals.noPriceMessage")}
      </p>
      <Carousel>
        {combiDealModal.combinableProductIds.map((productId) => (
          <ProductCard
            key={productId}
            productId={productId}
            className={styles.productCard}
            onClick={() => onClick(productId)}
            hidePrice
          />
        ))}
      </Carousel>
    </Modal>
  );
};

export default CombiDealModal;
